import { lazy } from 'react';

const PricingPage = lazy(() => import('../../pages/Pricing/PricingPage'));
const LoginPage = lazy(() => import('../../pages/Auth/Login'));
const SignupPage = lazy(() => import('../../pages/Auth/Signup'));
const OrgSignup = lazy(() => import('../../pages/Auth/OrgSignup'));
const VerifyOtp = lazy(() => import('../../pages/Auth/verify-otp.jsx'));
const ResetPassword = lazy(() => import('../../pages/Auth/reset-password.jsx'));
const NewPasswordReset = lazy(() => import('../../pages/Auth/password-reset.jsx'));
const GetProfile = lazy(() => import('../../pages/Auth/GetProfile'));
const EditProfile = lazy(() => import('../../pages/Auth/userProfile'));
const PublicJobApply = lazy(() => import('../../pages/Jobs/PublicJobApply/index'));
const PublicJobDetail = lazy(() => import('../../pages/Jobs/PublicJobDetail/index'));
const PublicCareersPage = lazy(() => import('../../pages/Jobs/PublicCareersPage/index'));
const AcceptInvite = lazy(() => import('../../pages/Auth/AcceptInvite'));
const ClientLogin = lazy(() => import('../../pages/Client/ClientLogin'));
const ClientDashboard = lazy(() => import('../../pages/Client/ClientDashboard'));
const ClientProjectDashboard = lazy(() => import('../../pages/Client/ClientProjectDashboard'));
const ClientCandidateView = lazy(() => import('../../pages/Client/ClientCandidateView'));

const commonRoutesConfig = [
  { path: '/pricing', component: PricingPage },
  { path: '/login', component: LoginPage },
  { path: '/signup', component: SignupPage },
  { path: '/org-signup', component: OrgSignup },
  { path: '/verify-otp', component: VerifyOtp },
  { path: '/reset-password', component: ResetPassword },
  { path: '/Password-reset', component: NewPasswordReset },
  { path: '/v1/profile', component: GetProfile },
  { path: '/v1/edit-profile', component: EditProfile },
  { path: '/jobs/:jobId', component: PublicJobDetail },
  { path: '/jobs/:jobId/apply', component: PublicJobApply },
  { path: '/careers', component: PublicCareersPage },
  { path: '/accept-invite', component: AcceptInvite },
  { path: '/client/login', component: ClientLogin },
  { path: '/client/dashboard', component: ClientDashboard },
  { path: '/client/projects/:project_id', component: ClientProjectDashboard },
  { path: '/client/projects/:project_id/candidates/:candidate_id', component: ClientCandidateView },
];

export default commonRoutesConfig;
